export { FacilitiesSearchContainer as default } from "containers/FacilitiesContainer";
